export const SmartestLiar = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2800 200"
      width="100%"
      height="auto"
      preserveAspectRatio="xMidYMid meet"
      className="min-w-0"
    >
      <style>
        {`
          text {
            font-family: "Comic Sans MS", "Arial Rounded MT Bold", "Trebuchet MS", sans-serif;
            font-weight: 900;
            fill: white;
            stroke: black;
            stroke-width: 28px;
            paint-order: stroke fill;
          }
        `}
      </style>

      {/* Single Line Text - centered in viewBox */}
      <text x="50%" y="60%" textAnchor="middle" fontSize="120">
        .The smartest liar is the winner
      </text>
    </svg>
  );
};
